var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scroll-pane",
    { attrs: { "scroll-event": "routes:init" } },
    [
      _c("action-header", { attrs: { slot: "header" }, slot: "header" }, [
        _c(
          "div",
          { staticClass: "search" },
          [
            _c("VueIcon", { attrs: { icon: "search" } }),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.filter,
                  expression: "filter",
                  modifiers: { trim: true }
                }
              ],
              ref: "filterRoutes",
              attrs: { placeholder: "Filter routes" },
              domProps: { value: _vm.filter },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.filter = $event.target.value.trim()
                },
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            })
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass: "tree",
          class: {
            "high-density": _vm.finalHighDensity
          },
          attrs: { slot: "scroll" },
          slot: "scroll"
        },
        _vm._l(_vm.filteredRoutes, function(route) {
          return _c("routes-tree-item", {
            key: route.path,
            ref: "instances",
            refInFor: true,
            attrs: {
              route: route,
              "route-id": _vm.routeChanges.indexOf(route),
              depth: 0
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }